import { actions } from '../../../actions';
import { createNewMessageFetch } from '../../ClientConfiguration/helpers';
import { isUndefined } from 'lodash';
import { standardString } from '../../../utils/utils';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

/**
 * Confirma y realiza una acción específica en un mensaje.
 *
 * @param {Object} options - Opciones para la acción.
 * @param {Object} options.message - El mensaje sobre el que se realizará la acción.
 * @param {string} options.action - La acción a realizar en el mensaje (en infinitivo y primera letra mayuscula).
 * @param {string} options.actionApi - La API o método específico para la acción.
 * @param {string} options.icon - El ícono a mostrar en el cuadro de diálogo.
 *
 * @throws {Error} Si hay un problema al realizar la acción.
 */
export const handleMessageAction = async ({
  messages,
  message,
  action,
  actionApi,
  icon,
  token,
  originType,
  appDispatch,
}) => {
  let result = {};
  let isAdd = false;
  let isReplyAdd = false;
  let snackbarSeverity = 'success';
  if (actionApi === 'add') {
    isAdd = true;
    isReplyAdd = message.reply;
  } else {
    result = await MySwal.fire({
      text: `¿Está seguro/a de que quiere ${action.toLowerCase()} el mensaje?`,
      showConfirmButton: true,
      showDenyButton: true,
      icon: icon,
      input: message.reply && 'checkbox',
      inputPlaceholder: message.reply && `${action} réplica `,
      inputValue: true,
    });
  }
  if (result.isConfirmed || isAdd) {
    try {
      const reply = message.reply && result.value;
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: true, priority: 1 },
      });
      await createNewMessageFetch(token, message, actionApi);
      let snackbarMessage = `Se ha ${action.toLowerCase()} el mensaje`.replace(/r([^r]*)$/, 'do$1');
      if (reply || isReplyAdd) {
        const replyChannel = originType === 0 ? 1 : 0;
        const replyMessage = messages.find(
          (e) => e.messageId === message.messageId && e.channel === replyChannel,
        );
        if (replyMessage || isAdd) {
          if (!isAdd) {
            message.id = replyMessage.id;
          }
          if (isAdd && replyMessage) {
            snackbarMessage += ' pero NO su réplica, ya existe.';
            snackbarSeverity = 'warning';
          } else {
            message.channel = replyChannel;
            await createNewMessageFetch(token, message, actionApi);
            snackbarMessage += ' y su réplica !';
          }
        } else {
          snackbarMessage += ' pero no se encontró su réplica.';
          snackbarSeverity = 'warning';
        }
      }
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage,
          snackbarSeverity,
        },
      });
    } catch (error) {
      console.log(error);
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: 'Un problema ha ocurrido, intente nuevamente.',
          snackbarSeverity: 'error',
        },
      });
    } finally {
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: false, priority: 1 },
      });
    }
  }
};

export const formatMessageToDB = ({ message, type, organizationId }) => {
  message.type = type;
  message.organizationId = organizationId;
  message.messageId = message.messageId.trim().toUpperCase();
  message.value = message.value.trim().toUpperCase();
  if (message.message) message.message = message.message.trim();
  return message;
};

export const validateInputs = (message) => {
  if (isUndefined(message.messageId) || message.messageId === '') return false;
  if (isUndefined(message.value) || message.value.trim() === '') return false;
  if (isUndefined(message.message) || message.message.trim() === '') return false;
  return true;
};

export const checkDuplicateMessageId = (messages, message) => {
  return messages.find(
    (e) =>
      standardString(e.messageId) === standardString(message.messageId) &&
      e.channel === message.channel,
  );
};
